import { render, staticRenderFns } from "./UDIOutlistDialogNew.vue?vue&type=template&id=8ef4969c&scoped=true"
import script from "./UDIOutlistDialogNew.vue?vue&type=script&lang=js"
export * from "./UDIOutlistDialogNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ef4969c",
  null
  
)

export default component.exports